import { ACTIONS } from 'UTILS/constants/ActionConstants';

export default function setLanguageAction(language) {
  return {
    type: ACTIONS.SET_LANGUAGE,
    language,
  };
}
